import { ReactElement, ReactNode, useState } from 'react';

import { CSSTransition } from '../CSSTransition';
import { OnVisible } from '../OnVisible';

interface FadeOnScrollType {
  uniqueKey?: string;
  animate?: boolean;
  children: ReactNode;
  enter?: boolean;
  onVisible?: (hasEntered: boolean) => void;
  transitionProps?: any;
  animationClass?: string;
}

const FadeOnScroll = (props: FadeOnScrollType): ReactElement => {
  const [isVisible, setVisible] = useState(false);

  const uniqKey = props.uniqueKey || '-no-key';
  return (
    <OnVisible
      onChange={(val: boolean) => {
        setVisible(val);
        props.onVisible && props.onVisible(false);
      }}
      visibleClassName='fadeup-visible'
      percent={5}
    >
      <CSSTransition
        in={props.enter === undefined ? isVisible : isVisible && props.enter}
        appear
        className={props.animationClass || 'fadeup'}
        key={uniqKey}
        onEntered={() => {
          props.onVisible && props.onVisible(true);
        }}
        timeout={150}
        {...props.transitionProps}
      >
        {props.children}
      </CSSTransition>
    </OnVisible>
  );
};

FadeOnScroll.defaultProps = {
  animateClass: 'fadeup'
};

export default FadeOnScroll;
